import { BikeCard } from "./bikeCard";
import { MassagedBikeAndSub, Variant, BIKE_VARIANTS } from "./lib";

export const VariantGrid = ({
  variant,
  bikes
}: {
  variant: Variant;
  bikes: MassagedBikeAndSub[];
}) => {
  return (
    <section id={variant.type} className="flex flex-col gap-8">
      <div className="flex flex-col max-w-[500px] md:max-w-full self-center w-full">
        <h2 className="self-start">{variant.title}</h2>
        <p>{variant.description}</p>
      </div>
      <div className="flex flex-col items-center gap-6 md:grid md:grid-cols-3 md:grid-rows-auto md:grid-flow-row h-1/2 md:w-full">
        {bikes.map((bike, index) => {
          const passengers = BIKE_VARIANTS[bike.variant].passengers;
          const price = bike.subscriptions?.at(0)?.price ?? null;
          const action =
            bike.availability === "available"
              ? ({ type: "order", href: `/sykler/bestill/${bike.id}` } as const)
              : ({
                  type: "notify",
                  href: `/sykler/${
                    bike.availability === "coming_soon" ? "interessentliste" : "venteliste"
                  }?bikeType=${encodeURIComponent(`${bike.brand} ${bike.model}`)}&source=bike-grid`,
                } as const);

          return (
            <BikeCard
              key={index}
              title={bike.model}
              subtitle={bike.brand}
              passengers={passengers}
              price={price}
              image={bike.image}
              href={bike.pageLink.href}
              action={action}
            />
          );
        })}
      </div>
    </section>
  );
};
